module.exports = __webpack_public_path__ + "static/media/walkthrough_arrow.4766a53e.svg";